import { useState, useEffect, useRef, useCallback } from 'react'
import styled from '@emotion/styled'

import { headerHeight } from 'config/theme'
import { useStateRef } from 'utils/hooks/dom'

export const useCustomSticky = () => {
  const [gridNode, gridRef] = useStateRef()
  const containerRef = useRef(null)
  // customTabsRef 目前應該還不會用到
  const customTabsRef = useRef(null)
  const [isSticky, setIsSticky] = useState(false)
  const handleScroll = useCallback(
    (gridRect, containerRect, customTabsRect) => {
      if (gridRect.top <= containerRect.top) {
        !isSticky && setIsSticky(true)
        !isSticky && console.log('set to sticky') // debug
      } else {
        isSticky && setIsSticky(false)
        isSticky && console.log('set to not sticky') // debug
      }
    },
    [isSticky]
  )
  useEffect(() => {
    const onContainerScroll = () => {
      if (gridNode) {
        handleScroll(
          gridNode.getBoundingClientRect(),
          containerRef.current?.getBoundingClientRect(),
          customTabsRef.current?.getBoundingClientRect()
        )
      }
    }
    containerRef.current?.addEventListener('scroll', onContainerScroll)
    customTabsRef.current?.addEventListener('scroll', onContainerScroll)
    return () => {
      containerRef.current?.removeEventListener('scroll', onContainerScroll)
      customTabsRef.current?.removeEventListener('scroll', onContainerScroll)
    }
  }, [handleScroll, gridNode, containerRef.current, customTabsRef.current])

  const [gridWidth, setGridWidth] = useState(0)
  const handleResize = useCallback(() => {
    if (gridNode) {
      // setGridWidth(gridNode.clientWidth)
      const style = window.getComputedStyle(gridNode)
      const width = parseInt(style.getPropertyValue('width'))
      const padding = parseInt(style.getPropertyValue('padding-left'))
      setGridWidth(width - padding * 2)
    }
  }, [gridNode])
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])
  useEffect(() => {
    if (gridNode) {
      const style = window.getComputedStyle(gridNode)
      const width = parseInt(style.getPropertyValue('width'))
      const padding = parseInt(style.getPropertyValue('padding-left'))
      setGridWidth(width - padding * 2)
    }
  }, [gridNode])

  return { gridRef, containerRef, isSticky, gridWidth, customTabsRef }
}

const Stickable = styled.div`
  ${({ $mobileFullWidth, theme }) =>
    $mobileFullWidth
      ? `
      ${theme.breakpoints.down('md')} {
        margin-left: -${theme.spacing(4)};
        margin-right: -${theme.spacing(4)};
        padding: 0 ${theme.spacing(4)};
        width: 100vw;
      }
    `
      : ''}
  ${({
    $isSticky,
    $isHideScrollbar = false,
    $isOverflowVisible,
    $hasHeader,
    $hasMarginBottom,
    $hasBottomShadow,
    theme,
    $height,
    $stickyWidth,
    $paddingBottom,
    $bgColor,
    $zIndex,
  }) =>
    $isSticky
      ? `
      position: sticky;
      margin-bottom: ${$hasMarginBottom ? theme.spacing(9) : ''};
      top: 0;
      height: ${$height ? $height : ''};
      width: ${$stickyWidth ? $stickyWidth + 'px' : '100%'};
      max-height: ${$hasHeader ? `calc(100vh - ${headerHeight})` : '100vh'};
      overflow-y: ${$isOverflowVisible ? 'visible' : 'auto'};
      padding-bottom: ${$paddingBottom ? `${$paddingBottom}px` : ''};
      background-color: ${$bgColor ? $bgColor : ''};
      box-shadow: ${$hasBottomShadow ? '0px 12px 16px 0px #0000001A' : ''};
      z-index: ${$zIndex ? $zIndex : 'auto'};

      ${
        $isHideScrollbar &&
        `
        ::-webkit-scrollbar {
          display: none;
        }
      `
      }
      `
      : ''}
`

export default Stickable
